import * as yup from 'yup';

declare module 'yup' {
  interface StringSchema {
    validEmail(message?: string): StringSchema;
    validDecimal(message?: string, minValue?: number, maxValue?: number): StringSchema;
  }
  interface NumberSchema {
    transformEmptyValueToUndefined(): NumberSchema;
  }
}

// Add the custom methods
yup.addMethod<yup.StringSchema>(yup.string, 'validEmail', function (message) {
  return this.test({
    name: 'validEmail',
    message: message || 'Invalid email format',
    test: function (value) {
      if (!value) return true; // Skip validation if empty (let required() handle it)
      // Basic email format validation
      const emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
      if (!emailRegex.test(value)) {
        return false;
      }
      return true;
    },
  });
});

yup.addMethod<yup.StringSchema>(yup.string, 'validDecimal', function (message, minValue, maxValue) {
  return this.test({
    name: 'validDecimal',
    message: message || 'Invalid decimal number',
    test: function (value) {
      if (!value) return true; // Skip validation if empty (let required() handle it)
      // Decimal format validation
      const decimalRegex = /^\d+[.,]?\d{0,2}(?<![.,])$/;
      if (!decimalRegex.test(value)) return false;
      const number = Number(value.replace(',', '.'));
      if (minValue !== undefined && number < minValue) return false;
      if (maxValue !== undefined && number > maxValue) return false;
      return true;
    },
  });
});

yup.addMethod<yup.NumberSchema>(yup.number, 'transformEmptyValueToUndefined', function () {
 return this.transform((value, originalValue) => {
   if (originalValue === '' || originalValue === null || originalValue === undefined) {
     return undefined;
   }
   return value;
 });
});
